// extracted by mini-css-extract-plugin
export var content = "article-module--content--934d2";
export var goBack = "article-module--goBack--9203b";
export var nextprev = "article-module--nextprev--9fbd7";
export var sidebar = "article-module--sidebar--aac9f";
export var sidebarLabel = "article-module--sidebarLabel--10247";